import { CnList } from '@/components/cn-list';

export default CnList;
